import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";


export const fetchDataActivity = createAsyncThunk(
    'activity/fetchData',
    async ({perPage=6, expectId=null,page=1}, { rejectWithValue }) => {
        try {
            
            const response = await api.get('/activities', {
                params: {
                    perPage: perPage,
                    expectId: expectId,
                    page
                }
            });
            
            
            const data = {data:response.data.data,total:response.data.total};
            return data;
        } catch (error) {
            rejectWithValue(error);
            console.log("error : ", error);
            return error;
        }

    }
)

export const activitySlice = createSlice({
    name: "activity",
    initialState: {
        loading: false,
        error: null,
        total: 0,
        activities: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchDataActivity.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchDataActivity.fulfilled, (state, action) => {
                state.loading = false;
                
                state.activities = action.payload.data;
                state.total = action.payload.total;

            })
            .addCase(fetchDataActivity.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.total=0;
            })
    }
});
// export const { getSettingRequest, getSettingSuccess, getSettingFailure } = activitySlice.actions;
export default activitySlice.reducer;
